<template>
    <section class="feature-placeholder">
        <div class="feature-placeholder__intro">
            <div class="feature-placeholder__badge">{{ badge }}</div>
            <div class="feature-placeholder__headline">
                <div class="feature-placeholder__icon">
                    <i :class="iconClass"></i>
                </div>
                <div>
                    <h2 class="feature-placeholder__title">{{ title }}</h2>
                    <p class="feature-placeholder__description mb-0">{{ description }}</p>
                </div>
            </div>
        </div>

        <div class="feature-placeholder__preview">
            <div class="feature-placeholder__panel">
                <div class="feature-placeholder__panel-header">
                    <div>
                        <div class="feature-placeholder__panel-title">{{ previewTitle }}</div>
                        <div class="feature-placeholder__panel-subtitle">
                            Cette fonctionnalité n'est pas encore prête à être utilisée côté client.
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-sm mb-0 feature-placeholder__table">
                        <thead>
                            <tr>
                                <th v-for="column in columns" :key="column">{{ column }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :colspan="columns.length" class="feature-placeholder__empty">
                                    <div class="feature-placeholder__empty-title">{{ emptyTitle }}</div>
                                    <div class="feature-placeholder__empty-text">{{ emptyDescription }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "OrderingTableFeaturePlaceholder",
    props: {
        badge: {
            type: String,
            default: "Bientôt disponible",
        },
        iconClass: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        previewTitle: {
            type: String,
            required: true,
        },
        emptyTitle: {
            type: String,
            required: true,
        },
        emptyDescription: {
            type: String,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.feature-placeholder {
    display: grid;
    gap: 24px;
    padding: 28px 0;
}

.feature-placeholder__intro {
    display: grid;
    gap: 14px;
    padding-top: 20px;
}

.feature-placeholder__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 8px 12px;
    border-radius: 999px;
    background: #fef3c7;
    color: #92400e;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.feature-placeholder__headline {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    padding: 24px;
    border: 1px solid #e5e7eb;
    border-radius: 24px;
    background: radial-gradient(circle at top right, rgba(249, 115, 22, 0.12), transparent 34%), linear-gradient(135deg, #fffdf8 0%, #ffffff 62%);
    box-shadow: 0 18px 35px rgba(15, 23, 42, 0.05);
}

.feature-placeholder__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 18px;
    background: #fff7ed;
    color: #c2410c;
    font-size: 24px;
}

.feature-placeholder__title {
    margin: 0 0 8px 0;
    color: #111827;
    font-size: 28px;
    font-weight: 800;
}

.feature-placeholder__description {
    max-width: 760px;
    color: #4b5563;
    font-size: 15px;
    line-height: 1.6;
}

.feature-placeholder__panel {
    overflow: hidden;
    border: 1px solid #e5e7eb;
    border-radius: 22px;
    background: #ffffff;
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.feature-placeholder__panel-header {
    padding: 22px 24px 18px;
    border-bottom: 1px solid #f3f4f6;
    background: linear-gradient(180deg, #fafaf9 0%, #ffffff 100%);
}

.feature-placeholder__panel-title {
    color: #111827;
    font-size: 16px;
    font-weight: 700;
}

.feature-placeholder__panel-subtitle {
    margin-top: 6px;
    color: #6b7280;
    font-size: 13px;
}

.feature-placeholder__table thead th {
    border-top: none;
    padding: 14px 24px;
    background: #f9fafb;
    color: #6b7280;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.feature-placeholder__empty {
    padding: 48px 24px;
    text-align: center;
    border-top: none;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.85) 0%, rgba(255, 247, 237, 0.9) 100%),
        repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0.4) 0, rgba(255, 255, 255, 0.4) 12px, transparent 12px, transparent 24px);
}

.feature-placeholder__empty-title {
    margin-bottom: 8px;
    color: #111827;
    font-size: 18px;
    font-weight: 700;
}

.feature-placeholder__empty-text {
    max-width: 540px;
    margin: 0 auto;
    color: #6b7280;
    font-size: 14px;
    line-height: 1.6;
}

@media (max-width: 991px) {
    .feature-placeholder__headline {
        flex-direction: column;
    }

    .feature-placeholder__title {
        font-size: 24px;
    }

    .feature-placeholder__table thead th,
    .feature-placeholder__empty {
        padding-left: 16px;
        padding-right: 16px;
    }
}
</style>
